import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const NotFound = () => {

  

  return (
    <Fragment>
     <Helmet>
      {/* TITLE */}
    <title>
      404 Page Not Found | The Page You’re Looking For Doesn’t Exist - Helper Ji
    </title>

    {/* DESCRIPTION */}
    <meta
      name="description"
      content="The page you are looking for might have been moved, removed, or is temporarily unavailable. Please return to homepage or use the navigation menu to find what you’re looking for."
    />

    {/* KEYWORDS (Optional but fine) */}
    <meta
      name="keywords"
      content="404 Page Not Found, Page Not Available, Page Missing, Broken Link Error, Website Error Page, Requested Page Not Found, Invalid URL Page, Page Moved Or Removed, Missing Web Page, Not Found Error Page, Broken Page Link, Incorrect URL Error, Page Does Not Exist"
    />

    {/* IMPORTANT: NOINDEX */}
    <meta name="robots" content="noindex, nofollow" />
    <meta name="googlebot" content="noindex, nofollow" />
    <meta name="bingbot" content="noindex, nofollow" />

    {/* OPTIONAL: PREVENT CANONICAL CONFUSION */}
    <link rel="canonical" href="https://www.helperji.in/404" />

    {/* WEBPAGE SCHEMA (OPTIONAL BUT CLEAN) */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "404 Page Not Found",
        "description": "The page you are looking for might have been moved, removed, or is temporarily unavailable.",
        "url": "https://www.helperji.in/404"
      }
      `}
    </script>
      <script type="text/javascript">
    {`
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "vuhgim22tp");
    `}
  </script>
    </Helmet>

    <div className="container-fluid vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="text-center">
        <h1 className="display-1 fw-bold text-danger">404</h1>
        <h3 className="mb-3">Page Not Found</h3>
        <p className="text-muted mb-4">
          Sorry, the page you are looking for does not exist or has been moved.
        </p>
        <Link to="/" className="btn btn-danger px-4 py-2">
          Go Back Home
        </Link>
      </div>
    </div>
    </Fragment>
  );
};

export default NotFound;
